import React from 'react';

import { useTablePrefilterContext } from '@work4all/components/lib/components/table/TablePrefilterProvider';

import { nameof } from '@work4all/data/lib/helper/nameof';

import { CostCenter } from '@work4all/models/lib/Classes/CostCenter.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/costCenter-table-schema.json';

const COSTCENTER_FORCE_REQUEST_FIELDS: CostCenter<EMode.query> = {
  id: null,
  name: null,
  number: null,
  lastNumber: null,
  disabled: null,
  additive: null,
  bankDetails: {
    id: null,
    iban: null,
    name: null,
  },
  bankDetailsId: null,
};

const defaultSort = [
  {
    field: nameof<CostCenter>('number'),
    direction: SortDirection.ASCENDING,
  },
];

export function CostCenterTable(props: IEntityTableV8) {
  const { prefilter } = useTablePrefilterContext();

  const dataTable = useEntityDataTableV8<CostCenter, never>({
    ...props,
    schema: schema as never,
    prefilter,
    defaultSort,
    forceRequestFields: COSTCENTER_FORCE_REQUEST_FIELDS,
  });

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      entityType={Entities.costCenter}
      areas={{
        left: null,
        right: null,
        bottom: null,
      }}
      actions={{
        createWidget: false,
        groupingEnabled: false,
        remove: undefined,
      }}
    />
  );
}
